import { useState } from "react";
import { trpc } from "@/lib/trpc";
import { Button } from "@/components/ui/button";

export function PaymentWelcomeStatus({ customerId }: { customerId: number }) {
  const [reviewed, setReviewed] = useState(false);
  const utils = trpc.useUtils();
  const status = trpc.customers.paymentWelcomeStatus.useQuery(
    { customerId },
    { refetchOnWindowFocus: false, refetchInterval: 15000 }
  );
  const retry = trpc.customers.retryPaymentWelcome.useMutation({
    onSuccess: () => {
      void status.refetch();
      void utils.warranties.getCustomerAccessReadiness.invalidate({
        customerId,
      });
    },
  });
  if (status.isLoading)
    return (
      <p className="text-sm text-muted-foreground">
        Loading payment welcome status...
      </p>
    );
  if (status.isError)
    return (
      <p className="text-sm text-destructive">
        Payment welcome status is unavailable.
      </p>
    );
  if (!status.data?.length) return null;
  return (
    <div className="mt-4 rounded-md border p-3 space-y-3">
      <h4 className="font-medium">Welcome after payment</h4>
      {status.data.map(row => (
        <div key={row.channel} className="text-sm">
          <p className="capitalize">
            {row.channel}: {row.status.replaceAll("_", " ")}
          </p>
          {row.lastError && (
            <p className="text-muted-foreground">{row.lastError}</p>
          )}
          {row.canRetry !== false && ["blocked", "review_required"].includes(row.status) && (
            <Button
              size="sm"
              variant="outline"
              disabled={
                retry.isPending ||
                (row.status === "review_required" && !reviewed)
              }
              onClick={() =>
                retry.mutate({
                  customerId,
                  channel: row.channel,
                  confirmDeliveryReviewed: reviewed,
                })
              }
            >
              Retry {row.channel} welcome
            </Button>
          )}
        </div>
      ))}
      {status.data.some(row => row.status === "review_required") && (
        <label className="flex gap-2 text-sm">
          <input
            type="checkbox"
            checked={reviewed}
            onChange={e => setReviewed(e.target.checked)}
          />
          I checked Communications and confirmed this welcome needs another
          send.
        </label>
      )}
      {retry.error && (
        <p className="text-sm text-destructive">{retry.error.message}</p>
      )}
    </div>
  );
}
